<template>
<div class="chapter">
<div class="inner_page">
<div class="ph" id="pgepubid00002">
<h2 class="nobreak" id="calibre_pb_0">THE HARDY BOYS:</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section002_split_000.vue?1c92a522